module.exports = __webpack_public_path__ + "static/img/apple-touch-icon-180x180.d704d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-touch-icon-180x180.png
// module id = 415
// module chunks = 1